import React from "react";
import { ProductCertification } from "./ProductDetailPageResult";

interface CertificationProps {
  certifications: ProductCertification[];
  isExpandedDescriptionTemplate?: boolean;
}

const Certifications = ({
  certifications,
  isExpandedDescriptionTemplate = false,
}: CertificationProps) => {
  const renderCertifications = (
    <ul className="certifications">
      {certifications.map((certification) => (
        <li className="cert-3-col" key={certification.id}>
          <div className="cert-child-container">
            <span className="cert-img">
              <img
                alt={certification.name}
                src={certification.resourcePath}
                loading="lazy"
              />
            </span>
            <span className="cert-text">
              <h3 className="cert-title">{certification.name}</h3>
              <p>{certification.description}</p>
            </span>
          </div>
        </li>
      ))}
    </ul>
  );
  return (
    <div data-component="Certifications" className="clear-both">
      <div
        className={`${
          isExpandedDescriptionTemplate
            ? "certification-container"
            : "certification_container"
        }`}
      >
        {isExpandedDescriptionTemplate ? (
          <div className="flex-outer">{renderCertifications}</div>
        ) : (
          <>{renderCertifications}</>
        )}
      </div>
    </div>
  );
};

export default Certifications;
